<template>
    <Button :icon="attrs.icon" @click="handleClick">
        {{attrs.title}}
    </Button>
</template>
<script>
    export default {
        name: 'LyButton',
        props: {
            attrs: {
                type: Object,
                default: _ => new Object()
            }
        },
        methods: {
            /**
             * 按钮点击的监听
             */
            handleClick () {
                 if (this.attrs.route.length > 0) { // 进行路由的跳转
                 
                    this.$router.push({path: this.attrs.route})
                } else { // 没有跳转路由，就进行数据提交的事件发送
                    this.$eventHub.$emit(this.$events.BTN_SUBMIT)
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// ../projectCore/src/components/button/src/index.vue